import { useState } from 'react';

import ButtonComponent from '@/components/global/Button';
import Modal from '@/components/global/Modal';
import { ExpiredToast } from '@/components/global/Toast';

import DynamicComponent from './DynamicComponent';

const ModalWrapper = ({
  blok: { ModalContent, ModalButtonLabel, modalSize, Button, template, ...rest }
}) => {
  const customButton = (Button && Button[0]) || {};
  const { position, variant, size, label } = customButton;

  const maxWidth = {
    s: '566px', // 500 - padding
    m: '702px', // 800 - padding
    l: '984px' // 1000 - padding
  };

  const paddings = {
    s: 'var(--spacing-base)',
    m: 'var(--spacing-xl)',
    l: 'var(--spacing-xl)'
  };

  // temp workaround to preview and test expired session modal
  const [showExpiredToast, setShowExpiredToast] = useState(false);
  if (template === 'expired-session')
    return (
      <>
        <ButtonComponent
          callBack={() => {
            setShowExpiredToast(true);
          }}
          variant={'primary'}
          size={'l'}
          align={'center'}
          type="button"
        >
          {ModalButtonLabel}
        </ButtonComponent>
        {showExpiredToast && (
          <ExpiredToast
            successToastAction={() => {
              setShowExpiredToast(false);
            }}
          />
        )}
      </>
    );

  return (
    <Modal
      buttonPosition={position}
      buttonVariant={variant}
      ModalButtonLabel={label || ModalButtonLabel}
      modalPadding={template ? '0' : paddings[modalSize]}
      maxWidth={maxWidth[modalSize]}
      buttonSize={size}
      template={template}
      {...rest}
    >
      {ModalContent.map((blok) => (
        <DynamicComponent blok={blok} key={blok._uid} />
      ))}
    </Modal>
  );
};

export default ModalWrapper;
